import(/* webpackMode: "eager", webpackExports: ["HomeLayoutClient"] */ "/opt/atlassian/pipelines/agent/build/packages/app/src/app/home.layout.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomePageClient"] */ "/opt/atlassian/pipelines/agent/build/packages/app/src/app/page.client.tsx");
